// extracted by mini-css-extract-plugin
export default {"modal":"App_modal__jwAA2","app":"App_app__GuJBs","container":"App_container__4L7Vo","content":"App_content__naSmy","menu":"App_menu__M8k5S"};